module.exports = __webpack_public_path__ + "static/media/banner-7.baae19cf.jpg";